import { Component, Input, OnInit, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { QualificationCategory } from 'app/models/qualification-category.model';
import { QualificationType } from 'app/models/qualification-type.model';
import { Qualification } from 'app/models/qualification.model';
import { SHARED_STANDALONE_IMPORTS } from 'app/shared/standalone-imports';
import { HeaderAppComponent } from '../header-app/header-app.component';

@Component({
  selector: 'app-selection',
  templateUrl: './selection.component.html',
  styleUrls: ['./selection.component.scss'],
  standalone: true,
  imports: [...SHARED_STANDALONE_IMPORTS, HeaderAppComponent],
})
export class SelectionComponent implements OnInit {
  private modalCtrl = inject(ModalController);

  @Input() options: Qualification[] | QualificationCategory[] | QualificationType[];
  @Input() selectedOption: string = null;
  @Input() title = '';
  public filteredOptions: Qualification[] | QualificationCategory[] | QualificationType[];

  ngOnInit() {
    this.filteredOptions = this.options;
  }

  public confirm(selectedOption: string): Promise<boolean> {
    this.selectedOption = selectedOption;
    let selectedOptionNumber = null;
    if (this.selectedOption !== null) {
      selectedOptionNumber = parseInt(this.selectedOption, 10);
    }
    return this.modalCtrl.dismiss(selectedOptionNumber, 'confirm');
  }

  public cancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(this.selectedOption, 'cancel');
  }

  public filterContent(searchInput): void {
    this.filteredOptions = this.options.filter((x) => x.name.toLowerCase().includes(searchInput.toLowerCase()));
  }
}
